import React from 'react';
import Slider from 'react-slick';

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: 'block' }}
      onClick={onClick}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 78 78"
        fill="none"
        className="text-fourPrimary"
      >
        <g filter="url(#filter0_d_2699_2954)">
          <circle cx="39.2062" cy="34.9406" r="34.7941" fill="currentColor" />
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M46.3856 35.4913L35.3404 46.5371L33.3418 44.5378L42.3883 35.4913L33.3418 26.4448L35.3404 24.4456L46.3856 35.4913Z"
          fill="white"
        />
        <defs>
          <filter
            id="filter0_d_2699_2954"
            x="0.412109"
            y="0.146484"
            width="77.5879"
            height="77.5879"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_2699_2954"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_2699_2954"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: 'block' }}
      onClick={onClick}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 78 78"
        fill="none"
        className="text-fourPrimary"
      >
        <g filter="url(#filter0_d_2699_2954)">
          <circle cx="39.2062" cy="34.9406" r="34.7941" fill="currentColor" />
        </g>
        <path
          xmlns="http://www.w3.org/2000/svg"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32.9289 35.495L43.974 24.4492L45.9727 26.4486L36.9262 35.4951L45.9727 44.5416L43.974 46.5407L32.9289 35.495Z"
          fill="white"
        />
        <defs>
          <filter
            id="filter0_d_2699_2954"
            x="0.412109"
            y="0.146484"
            width="77.5879"
            height="77.5879"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_2699_2954"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_2699_2954"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </div>
  );
}

function SimpleSlider({ images }) {
  const settings = {
    dots: false,
    dotsClass: 'slick-dots slick-thumb',
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: images?.length > 1 && <SampleNextArrow />,
    prevArrow: images?.length > 1 && <SamplePrevArrow />,
  };
  return (
    <div className="slider-container imageSlider-box">
      <Slider {...settings}>
        {images?.map((image, index) => (
          <div key={index} className="img-slid-eight">
            <img src={image?.url} alt={`Slide ${index}`} />
          </div>
        ))}
      </Slider>
    </div>
  );
}

export default SimpleSlider;
